/**
 * DEV-2399, ADR-0064. Вход от имени пользователя, только просмотр: плашка
 * вкладки просмотра, модалка подтверждения, экраны входа и завершения, тосты
 * отказа, пункт меню и строки журнала доступов.
 *
 * Тексты не называют пол человека: имя подставляется, а «его/её» относится к
 * CRM или к пользователю как к слову.
 */
export const impersonationMessages = {
  ru: {
    impersonation: {
      opening: 'Открываем вкладку просмотра…',
      linkInvalidTitle: 'Ссылка для просмотра недействительна',
      linkInvalidDescription:
        'Она одноразовая и действует минуту. Начните просмотр заново из раздела «Пользователи».',
      endedTitle: 'Сеанс просмотра завершён',
      endedDescription: 'Вкладку можно закрыть — ваш собственный сеанс не затронут.',
      closeTab: 'Закрыть вкладку',
      endMenu: 'Завершить просмотр',
      readOnlyToast: 'В режиме просмотра изменения недоступны',
      hiddenToast: 'Эти данные недоступны в режиме просмотра',
      unsupportedToast: 'Этот раздел пока недоступен в режиме просмотра',
      banner: {
        viewingAs: 'Вы смотрите CRM как',
        readOnly: 'Только просмотр',
        remaining: 'ещё {minutes} мин',
        end: 'Завершить',
      },
      confirm: {
        title: 'Войти как {name}?',
        text: 'Откроется новая вкладка с CRM такой, какой её видит {name}: меню, клиенты и сделки этого пользователя. Изменить ничего нельзя.',
        textAgent:
          'Откроется новая вкладка с кабинетом агента таким, каким его видит {name}. Изменить ничего нельзя.',
        note: 'Сеанс длится 60 минут, вход попадёт в журнал доступов.',
        open: 'Открыть вкладку',
        close: 'Закрыть',
        failed: 'Не удалось начать просмотр. Попробуйте ещё раз.',
      },
    },
    admin: {
      users: {
        actions: { impersonate: 'Войти как пользователь' },
        detail: {
          history: {
            actions: {
              IMPERSONATION_START: 'Вход от имени',
              IMPERSONATION_END: 'Выход из просмотра',
            },
          },
        },
      },
      rbac: {
        audit: {
          actions: {
            IMPERSONATION_START: 'вход от имени',
            IMPERSONATION_END: 'выход из просмотра',
          },
        },
      },
    },
  },
  en: {
    impersonation: {
      opening: 'Opening the viewing tab…',
      linkInvalidTitle: 'The viewing link is invalid',
      linkInvalidDescription:
        'It works once and for one minute. Start viewing again from the Users section.',
      endedTitle: 'Viewing session ended',
      endedDescription: 'You can close this tab — your own session is not affected.',
      closeTab: 'Close tab',
      endMenu: 'Stop viewing',
      readOnlyToast: 'Changes are not available in viewing mode',
      hiddenToast: 'This data is not available in viewing mode',
      unsupportedToast: 'This section is not available in viewing mode yet',
      banner: {
        viewingAs: 'You are viewing the CRM as',
        readOnly: 'Read-only',
        remaining: '{minutes} min left',
        end: 'Stop',
      },
      confirm: {
        title: 'View as {name}?',
        text: 'A new tab will open with the CRM as {name} sees it: this user’s menu, clients and deals. Nothing can be changed.',
        textAgent:
          'A new tab will open with the agent cabinet as {name} sees it. Nothing can be changed.',
        note: 'The session lasts 60 minutes and is recorded in the access log.',
        open: 'Open tab',
        close: 'Close',
        failed: 'Could not start viewing. Please try again.',
      },
    },
    admin: {
      users: {
        actions: { impersonate: 'View as user' },
        detail: {
          history: {
            actions: {
              IMPERSONATION_START: 'Viewed as user',
              IMPERSONATION_END: 'Viewing stopped',
            },
          },
        },
      },
      rbac: {
        audit: {
          actions: {
            IMPERSONATION_START: 'viewed as user',
            IMPERSONATION_END: 'stopped viewing',
          },
        },
      },
    },
  },
  vn: {
    impersonation: {
      opening: 'Đang mở tab xem…',
      linkInvalidTitle: 'Liên kết xem không hợp lệ',
      linkInvalidDescription:
        'Liên kết chỉ dùng một lần trong một phút. Hãy bắt đầu xem lại từ mục «Người dùng».',
      endedTitle: 'Phiên xem đã kết thúc',
      endedDescription: 'Bạn có thể đóng tab này — phiên của bạn không bị ảnh hưởng.',
      closeTab: 'Đóng tab',
      endMenu: 'Kết thúc xem',
      readOnlyToast: 'Không thể thay đổi trong chế độ xem',
      hiddenToast: 'Dữ liệu này không khả dụng trong chế độ xem',
      unsupportedToast: 'Mục này chưa khả dụng trong chế độ xem',
      banner: {
        viewingAs: 'Bạn đang xem CRM dưới tên',
        readOnly: 'Chỉ xem',
        remaining: 'còn {minutes} phút',
        end: 'Kết thúc',
      },
      confirm: {
        title: 'Xem dưới tên {name}?',
        text: 'Một tab mới sẽ mở CRM như {name} nhìn thấy: menu, khách hàng và giao dịch của người dùng này. Không thể thay đổi gì.',
        textAgent: 'Một tab mới sẽ mở trang đại lý như {name} nhìn thấy. Không thể thay đổi gì.',
        note: 'Phiên kéo dài 60 phút và được ghi vào nhật ký truy cập.',
        open: 'Mở tab',
        close: 'Đóng',
        failed: 'Không thể bắt đầu xem. Vui lòng thử lại.',
      },
    },
    admin: {
      users: {
        actions: { impersonate: 'Xem dưới tên người dùng' },
        detail: {
          history: {
            actions: {
              IMPERSONATION_START: 'Xem dưới tên người dùng',
              IMPERSONATION_END: 'Kết thúc xem',
            },
          },
        },
      },
      rbac: {
        audit: {
          actions: {
            IMPERSONATION_START: 'xem dưới tên người dùng',
            IMPERSONATION_END: 'kết thúc xem',
          },
        },
      },
    },
  },
}
